import { render, staticRenderFns } from "./CreateFormkf.vue?vue&type=template&id=7a4c3001"
import script from "./CreateFormkf.vue?vue&type=script&lang=js"
export * from "./CreateFormkf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports